const LocationIcon = ({ color = "#FCF7EE", size = 30, ...props }) => {
    return(
       <svg 
            width={size} 
            height={size} 
            viewBox="0 0 30 30" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path 
                d="M15.0005 8.55005C17.3875 8.55026 19.3374 10.4901 19.3374 12.8879C19.3372 15.284 17.3891 17.2119 15.0005 17.2122C12.6134 17.2122 10.6627 15.2732 10.6626 12.8752C10.6626 10.4789 12.6116 8.55005 15.0005 8.55005ZM15.0005 9.42505C13.1007 9.42505 11.5376 10.9729 11.5376 12.8879C11.5378 14.8014 13.087 16.3499 15.0005 16.3499C16.9138 16.3496 18.4622 14.8013 18.4624 12.8879C18.4624 10.9731 16.9001 9.42526 15.0005 9.42505Z" 
                fill="#1C2A46" 
                stroke={color}
            />
            <path 
                d="M15 2.0625H15.0127C19.5016 2.06254 24.5883 4.69211 25.9121 10.5352C27.376 17.0027 23.4735 22.4803 19.8154 26.002C18.4607 27.2977 16.7236 27.9502 15 27.9502C13.3836 27.9502 11.7551 27.3765 10.4414 26.2363L10.1836 26.001C6.52605 22.4795 2.62391 16.9901 4.09961 10.5234H4.10059C5.42412 4.69273 10.5107 2.06254 15 2.0625ZM15 2.9375C11.2137 2.93754 6.26917 4.96321 4.96289 10.7129C3.54976 16.8757 7.43012 22.1251 10.8037 25.3604C13.1597 27.6339 16.853 27.6339 19.209 25.3604C22.5699 22.1254 26.4492 16.8766 25.0625 10.7148V10.7129L24.9287 10.1846C23.4352 4.83813 18.6678 2.9375 15 2.9375Z" 
                fill="#1C2A46" 
                stroke={color}
            />
        </svg>
    )
}

export default LocationIcon